"use client";

import { useSession } from "@/components/SupabaseProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type StatusUpdateParams = {
  subscriptionId: string;
  action: "cancel" | "renew" | "pause" | "resume";
};

export const useSubscriptionStatusUpdate = () => {
  const session = useSession();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ subscriptionId, action }: StatusUpdateParams) => {
      if (!session?.access_token) {
        throw new Error("No session found");
      }

      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/billing/subscription/${subscriptionId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${session.access_token}`,
          },
          method: "PATCH",
          body: JSON.stringify({ action }),
        }
      );

      if (res.status === 401) {
        throw new Error("Please login to continue");
      }
      if (!res.ok) {
        throw new Error(`Something went wrong (status ${res.status})`);
      }

      queryClient.invalidateQueries({
        queryKey: ["subscriptions"],
      });
      return res.json();
    },
  });
};
